// The latest documented decision per object, for the pages that show a small mark on a row once something is decided.
// itemKey is the object (a requirement, a setting, a policy); findingKey says which page it was written on (cmp:..., cfg:...).
export function decisionsByItem(notes, findingPrefix) {
  const latest = new Map();
  (notes || []).forEach((n) => {
    if (!n.itemKey || !n.decisionType || !String(n.findingKey || '').startsWith(findingPrefix)) return;
    const prev = latest.get(n.itemKey);
    if (!prev || new Date(n.createdAt) > new Date(prev.createdAt)) latest.set(n.itemKey, n);
  });
  return latest;
}
